import { ViewTableUtils, type ViewTableColumnsLayoutType } from 'app/main/components/page-layouts';

const useUsersLoginLogsColumns: ViewTableColumnsLayoutType = ({ t }) => [
	{
		field: 'user_title',
		headerName: t('LOGS_COLUMN_USER'),
		minWidth: 300,
		flex: 1,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'logs_date',
		headerName: t('LOGS_COLUMN_LOGIN_DATE'),
		minWidth: 200,
		renderCell: ({ value }) =>
			ViewTableUtils.renderDate({
				value,
				format: { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }
			}),
		headerAlign: 'right',
		align: 'right',
		hideable: false
	}
];

export default useUsersLoginLogsColumns;
